import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { AuthService } from '../auth.service';
import { AlertService } from './alert.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  constructor(
    private readonly authService: AuthService,
    private readonly alertService: AlertService,
    private readonly router: Router
  ) { }

  public catchBadResponse(err: HttpErrorResponse, urlRedirect: string = ''): Observable<any> {
    const error: any = { code: err.error.code, message: err.error.message, status: err.status };
    let titulo: string = '';
    let subtitulo: string = '';
    switch (err.status) {
      case 401:
        if (error.code === 'TOKEN_REVOKED_NEW_SESSION') {
          titulo = 'Su sesión ha sido cerrada por que se inició en otro dispositivo o navegador';
          subtitulo = 'Por favor vuelva a ingresar';
        } else {
          if (this.authService.getToken()) {
            titulo = 'Su sesión ha expirado';
            subtitulo = 'Por favor vuelva a ingresar';
          } else {
            titulo = 'Disponible solo para usuarios registrados';
            subtitulo = 'Por favor ingrese con sus credenciales';
          }
        }
        this.alertService.alertError(titulo, subtitulo, 'Ingresar').then(resp => {
          this.authService.logout();
          this.router.navigate(["/auth/ingreso"]);
        });
        break;
      default:
        this.alertService.alertError('Ups', 'Ocurrió un problema. Vuelve a intentar.').then(resp => {
          urlRedirect && this.router.navigate([`/${urlRedirect}`]);
        });
        break;
    }
    return throwError(error);
  }
}
